import * as ActionTypes from './actionTypes';
import {
    flattenDataErrorMessages,
    getServerError,
    getDataError
} from '../helpers/errors';

export const clearErrors = () => ({
    type:    ActionTypes.SET_APPLICATION_ERROR,
    payload: []
});

export const handleError = error => ({
    type:    ActionTypes.SET_APPLICATION_ERROR,
    payload: [error]
});

export const enqueueSnackbar = (notification, status, isExport = false) => ({
    type:         ActionTypes.ENQUEUE_SNACKBAR,
    notification: {
        key: new Date().getTime() + Math.random(),
        notification,
        status,
        isExport
    }
});

export const removeSnackbar = key => ({
    type: ActionTypes.REMOVE_SNACKBAR,
    key
});

export const handleNetworkError = error => dispatch => {
    if (error.response) {
        const dataError = getDataError(error);

        if (dataError) {
            let messages = flattenDataErrorMessages(dataError);
            if (!Array.isArray(messages)) {
                messages = dataError;
            }

            dispatch({
                type:    ActionTypes.SET_APPLICATION_ERROR,
                payload: messages
            });

            if (Array.isArray(messages) && messages.length > 1) {
                dispatch(enqueueSnackbar('Multiple server errors occurred.', 'error'));
            } else if (Array.isArray(messages)) {
                dispatch(enqueueSnackbar(messages[0], 'error'));
            }
            else {
                dispatch(enqueueSnackbar(messages, 'error'));
            }
            return;
        }
        const serverError = getServerError(error);
        dispatch(enqueueSnackbar(serverError, 'error'));
    } else if (error.request) {
        dispatch(enqueueSnackbar(error.message, 'error'));
        // no response received
    } else {
        dispatch(enqueueSnackbar(error.message || error, 'error'));
        // error when setting up request
    }
};
